import React from "react";
import { Label } from "semantic-ui-react";

export const InvoiceComponentFintechLabel = ({ customer = {} }) => {
    if (!customer?.fintech_option || !customer?.fintech_id) {
        return null;
    }

    return <Label color="blue">Fintech</Label>;
};
